import React from 'react';
import { Row, Col } from 'shards-react';
import ReactGA from 'react-ga';
import DownloadButton from './DownloadButton';
import DownloadExp from './DownloadExp';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { showErrorMessage, downloadMillSheet } from '../../../redux/slices/millSheetSearch';
import { MAX_PDF_DOWNLOAD } from '../../../constants';

const MillsheetDownload = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { isDownloading, selectedRows } = useSelector((state: RootState) => state.millSheetSearch);
  const isDownloadable: boolean = 0 < selectedRows.length && selectedRows.length <= MAX_PDF_DOWNLOAD;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================
  /**
   * ミルシートのダウンロード
   */
  const handleDownload = (): void => {
    ReactGA.ga('send', 'event', 'millsheetSearch', 'pdfDownload', 'pdfDownloadButton');
    const files: string[] = selectedRows.map((rows) => rows._id);
    if (files.length > MAX_PDF_DOWNLOAD) {
      const message: string = files.length + '件選択されています。一度にダウンロードできる件数は' + MAX_PDF_DOWNLOAD + '件までです。';
      dispatch(showErrorMessage(message));
    } else {
      dispatch(downloadMillSheet(files));
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Row form>
        <Col md="2" className="d-flex align-items-center">
          <DownloadButton isDownloadable={isDownloadable} isDownloading={isDownloading} onDownload={handleDownload} />
        </Col>
        <Col className="d-flex align-items-center">
          <DownloadExp />
        </Col>
      </Row>
    </>
  );
};

export default MillsheetDownload;
